<div id="line_widget_container">
  <div class="chart-wrapper">
    <canvas
    class="lineChart"
    [ngClass]="{ hide: loading() || timeOut() }"
    [id]="chartId()"
    ></canvas>
  </div>
  @if (timeOut()) {
    <app-timeout></app-timeout>
  } @else if (loading()) {
    <div class="flex justify-content-center align-items-center h-full">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  }
  

  <div class="chartFilter">
    <div class="timeWindow">
      <span class="pointer" (click)="previousTimeWindow()">&lt;</span>
      <p-floatLabel>
        <p-datepicker
          [showWeek]="true"
          [firstDayOfWeek]="1"
          [ngModel]="date()"
          (ngModelChange)="date.set($event)"
          [view]="calendarView()"
          [dateFormat]="dateFormat()"
          [readonlyInput]="true"
          inputId="date"
          (onSelect)="setTimeWindow()"
        >
        </p-datepicker>
        <label for="date">{{
          "energy_tool.bar_chart.time_window" | translate
        }}</label>
      </p-floatLabel>
      <span class="pointer" (click)="nextTimeWindow()">&gt;</span>
    </div>
    <div class="aggregationOptions">
      @for (option of timeFrameOptions; track option) {
        <span
          [ngClass]="{
            selected: currentTimeFrame() === option.value,
            borderLeft: $index !== 0,
          }"
          (click)="clickTimeframeOption(option.value)"
        >
          {{ option.label | translate }}
        </span>
      }
    </div>
  </div>
</div>
